export default __webpack_public_path__ + "static/media/bannerr1.cbbaabf5.webp";